import React from 'react';
import { Navigate } from 'react-router-dom';
import { useStudioUnauthenticatedContext } from '../context/StudioContext';

export const RequireAuth: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { currentUser } = useStudioUnauthenticatedContext();

  if (currentUser === null) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};
